export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
        ],
        
        headerFields: [
            {
                name: "sztszt",
                label: "SZTSZ",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "patientName",
                label: "Páciens neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "costPlaces",
                label: "Költség helyek",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "cost_place_name",
                label: "Költséghely neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "partnerId",
                label: "Partner azonosító",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "partnerName",
                label: "Partner név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "groupId",
                label: "Pozició azonosító",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "groupName",
                label: "Pozíciónév",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "birthCity",
                label: "Születési város",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "sex",
                label: "Nem",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "motherName",
                label: "Édesanyja neve",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "zipCode",
                label: "Irányítószám",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "city",
                label: "Város",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "patientStreet",
                label: "Utca",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "patientEmail",
                label: "Email cím",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "patientPhone",
                label: "Telefonszám",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "jobCategoryId",
                label: "jobCategoryId",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: false,
            },
            {
                name: "treatmentTypeTitle",
                label: "Kezelés típusa",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "employabilityStatusName",
                label: "Eredmény",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "feorCode",
                label: "FEOR kód",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "employementStartDate",
                label: "Munkaviszony kezdete",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "treatmentDate",
                label: "Kezelés dátuma",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "treatmentResultDate",
                label: "Eredmény dátuma",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ szám",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
        ]
    }
}
